import ControllerBase from "global/js/ControllerBase";
import { MoleculeInputSearchFatEvent, MoleculeInputSearchFatEvents } from "./m-input-search-fat.events";

interface ComponentRefs {
	searchFatWrapper: 'searchFatWrapper';
	searchFatInput: 'searchFatInput';
	searchFatButton: 'searchFatButton';
	clearSearchFatField: 'clearSearchFatField';
}

export default class ControllerInputSearchFat extends ControllerBase<ComponentRefs> {
	/** Defining variables types */
	private search: HTMLInputElement;
	private wrapper: HTMLDivElement;
	private clear: HTMLSpanElement;
	private button: HTMLButtonElement;


	constructor(element: HTMLElement) {
		super(element);

		/** Variable declaration */
		this.search = this.$references.searchFatInput as HTMLInputElement;
		this.wrapper = this.$references.searchFatWrapper as HTMLDivElement;
		this.button = this.$references.searchFatButton as HTMLButtonElement;
		this.clear = this.$references.clearSearchFatField as HTMLSpanElement;

		this.init();
	}

	private init(): void {
		this.detectInputState();
		this.clearField();

		this.search &&
			this.search.addEventListener('keyup', (event) => this.handleSubmitEvent(event))
		this.button &&
			this.button.addEventListener('click', (event) => this.handleSubmitClickEvent(event))
	}

	/**
	 * Emits a event to the parent that fires the API call
	 * @param {KeyboardEvent} event
	 */
	handleSubmitEvent(event: KeyboardEvent): void {
		if (event.key === 'Enter') {
			this.emitEvent();
		}
	}

	/**
	 * Emits a event to the parent that fires the API call
	 * @param {MouseEvent} event
	 */
	private handleSubmitClickEvent(event: MouseEvent): void {
		this.emitEvent();
	}

	/**
	 * Add event on input field depending if empty or not
	 */
	private detectInputState(): void {
		this.search && this.search.addEventListener('input', (event) => this.handleInputEvent(event));
	}

	/**
	 * If empty hide clear button
	 * @returns void
	 */
	private handleInputEvent(event: Event): void {
		const input = event.target as HTMLInputElement;
		const searchValue = input.value;

		searchValue && searchValue.length > 0 ? this.wrapper.classList.remove('empty') : this.wrapper.classList.add('empty');
	}

	/**
	 * Add event for clear button
	 */
	private clearField(): void {
		this.clear && this.clear.addEventListener('click', () => this.clearInputField());
	}

	/**
	 * Clears the input value
	 */
	private clearInputField(): void {
		this.search.value = '';
		this.wrapper.classList.add('empty');
	}

	/**
	 * Creates the event
	 */
	private emitEvent(): void {
		this.dispatchCustomEvent<MoleculeInputSearchFatEvent>(MoleculeInputSearchFatEvents.search, { searchValue: this.search.value }, true, true);
	}
}
